export default __webpack_public_path__ + "static/media/videos.351c551c.svg";